import {Chart} from 'chart.js';

export type ColorPair = readonly [string, string];

export function isGradient(color: string | ColorPair): color is ColorPair {
  return Array.isArray(color);
}

export function getCssGradient(colors: ColorPair) {
  let distance = 0;
  return `repeating-linear-gradient(45deg, ${colors
    .map((color) => `${color} ${distance}px ${(distance += 5.4)}px`)
    .join(', ')})`;
}

export function getCanvasGradient(chart: Chart, colors: ColorPair) {
  const {ctx, chartArea} = chart;

  if (!chartArea) {
    return;
  }

  const offset = 0.02;
  const gradient = ctx.createLinearGradient(0, chartArea.height, chartArea.width, 1);
  gradient.addColorStop(0, colors[0]);
  const stopsCount = Math.floor(1 / offset);

  Array.from({length: stopsCount}, (_, i) => i * offset).forEach((stop, i) => {
    const colorIndex = i % 2;
    gradient.addColorStop(stop, colors[colorIndex]);
    gradient.addColorStop(stop, colors[colorIndex === 0 ? 1 : 0]);
  });

  gradient.addColorStop(1, colors[1]);

  return gradient;
}
